import React, { useRef, useState } from "react";
import { Button, Form, Input, message } from "antd";
import { Link } from "react-router-dom";
import sanitizeHtml from "sanitize-html";
import ReactHtmlParser from "react-html-parser";
import { useAuth } from "../../../authentication";
import AppNotificationContainer from "../../../components/AppNotificationContainer";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import LoginBackground from "../../../assets/Images/PR-logo.jpeg";
import ReCAPTCHA from "react-google-recaptcha";
import { captchaSiteKey } from "../../../theme/constants";

const LogIn = () => {
  const recaptchaRef = useRef();
  const { isLoading, error, userLogin } = useAuth();
  const [btnDisable, setDtnDisable] = useState(true);
  const regex = /(<([^>]+)>)/gi;
  const regex1 = /[\]}[{]/gi;

  const onFinish = (values) => {
    let tempUserEmail = sanitizeHtml(values.email)
      .replace(regex, "")
      .replace(regex1, "");
    let tempUserPassword = ReactHtmlParser(sanitizeHtml(values.password));

    if (tempUserEmail !== "" && tempUserPassword !== "") {
      const payload = {
        email: tempUserEmail,
        password: tempUserPassword[0],
      };

      userLogin(payload);
    } else {
      message.error("Invalid data. Please put valid data in the fields.");
    }
  };

  // Captcha onchange
  const onChangeCaptcha = (value) => {
    if (value) {
      setDtnDisable(false);
    } else {
      setDtnDisable(true);
    }
  };

  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg">
              <img src={LoginBackground} alt="background" />
              <span
                style={{ color: "white", fontSize: "20px", fontWeight: "bold" }}
              >
                PERFIT ROCKS
              </span>
            </div>
            <div className="gx-app-logo-wid">
              <h1 style={{ paddingLeft: "18px" }}>Login</h1>
            </div>
            <div className="gx-app-logo">
              {/* <img alt="example" src={logo}/> */}
              <span
                style={{ color: "white", fontSize: "20px", fontWeight: "bold" }}
              >
                PERFIT ROCKS
              </span>
            </div>
          </div>

          <div className="gx-app-login-content">
            <Form
              initialValues={{ remember: true }}
              name="basic"
              onFinish={onFinish}
              className="gx-signin-form gx-form-row0"
            >
              <Form.Item
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: (
                      <span className="custom-error-message">
                        Please enter email address.
                      </span>
                    ),
                  },
                  {
                    type: "email",
                    message: (
                      <span className="custom-error-message">
                        Please enter valid email address.
                      </span>
                    ),
                  },
                ]}
                hasFeedback
                name="email"
              >
                <Input prefix={<UserOutlined />} placeholder="Email" />
              </Form.Item>

              <Form.Item
                rules={[
                  {
                    required: true,
                    message: (
                      <span className="custom-error-message">
                        Please enter password.
                      </span>
                    ),
                  },
                ]}
                hasFeedback
                name="password"
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  type="password"
                  placeholder="Password"
                />
              </Form.Item>

              <Form.Item>
                <ReCAPTCHA
                  style={{ width: "100%" }}
                  ref={recaptchaRef}
                  type={"image"}
                  sitekey={captchaSiteKey}
                  onChange={onChangeCaptcha}
                />
              </Form.Item>

              <Form.Item className="signin-bottom-links">
                <Button
                  type="primary"
                  className="gx-mb-0"
                  htmlType="submit"
                  disabled={btnDisable}
                  loading={isLoading}
                >
                  Login
                </Button>
                <Link className="link-underline" to="/forgotpassword">
                  Forgot Password?
                </Link>
              </Form.Item>
            </Form>
          </div>
          <AppNotificationContainer loading={isLoading} error={error} />
        </div>
      </div>
    </div>
  );
};

export default LogIn;
